import React from 'react';
import { useSelector } from 'react-redux';
import FavoritesList from '../favorites/FavoritesList';

const FavoritesWidget = () => {
  const { favoriteList } = useSelector(state => state.app.userData);
  return <FavoritesList listId={favoriteList.id} list={favoriteList.list} readOnly className="widget" />;
};

export default FavoritesWidget;
